export default "__VITE_ASSET__C13T7Fu2__"